<template>
    <div>
      <div v-if="isSmallScreen"> 
        <OurEquipmentSmallScreen />
      </div>
      <div v-else>
        <OurEquipmentBigScreen />
      </div>
    </div>
  </template>
  
  <script>
  import OurEquipmentSmallScreen from './OurEquipmentSmallScreen.vue';
  import OurEquipmentBigScreen from './OurEquipmentBigScreen.vue';
  
  export default {
    components: {
        OurEquipmentSmallScreen,
        OurEquipmentBigScreen
    },
    computed: {
      isSmallScreen() {
        return window.innerWidth <= 768;
      }
    },
    mounted() {
      if (this.isSmallScreen) {
        this.loadSmallScreenScripts();
      } else {
        this.loadLargeScreenScripts();
      }
    },
    methods: {
      loadSmallScreenScripts() {
        const script = document.createElement('script');
        
        script.async = true;
        document.head.appendChild(script);
      },
      loadLargeScreenScripts() {
        const script = document.createElement('script');
        
        script.async = true;
        document.head.appendChild(script);
      }
    }
  }
  </script>
  